export default __webpack_public_path__ + "0a01be8b766b677f351f0562ac5d0914.png";